<template>
	<div>
		<v-bottom-sheet persistent v-model="orderChallanSheet" v-if="orderChallanSheet">
			<v-card>
				<v-subheader class="pl-0"> <v-btn icon @click="closeDialog"><v-icon>close</v-icon></v-btn> 
					<span v-if="formType == 'sale'">{{ $parent.Form.transactionData.transactionListId == 10002 ? 'Add Order' : $parent.Form.transactionData.transactionListId == 10003 ? 'Add Order/Delivery Challan' : 'Add Invoice' }} </span>
					<span v-else>{{ $parent.Form.transactionData.transactionListId == 20002 ? 'Add Purchase Order' : $parent.Form.transactionData.transactionListId == 20003 ? 'Add Purchase Order/Challan' : 'Add Purchase Invoice' }} </span>
				</v-subheader>
				<v-card-text class="pa-0 pb-3">
					<v-list nopadding>
						<v-list-tile :key="'item_'+key" @click="fn_openItems(key)" class="ma-3 pending-count-tile" style="border-radius: 8px;" v-for="(count, key) in $parent.Form.pendingOrderAndChallan">
							<v-list-tile-content>
								<v-list-tile-title>
									<!-- <span v-if="key == 10001">{{ count }} {{ count > 1 ? "Orders are pending" : "Order is pending" }}</span>
									<span v-if="key == 10002">{{ count }} {{ count > 1 ? "Delivery Challan are pending" : "Delivery Challan is pending" }}</span>
									<span v-if="key == 10003">{{ count > 1 ? "Invoices" : "Invoice" }} ({{ count }})</span> -->

									<template v-if="key == 10001 || key == 20001">{{ count }} {{key == 10001 ? 'Order' : 'Purchase Order'}}{{ count > 1 ? "s are pending" : " is pending" }}</template>
									<template v-if="key == 10002 || key == 20002">{{ count }} {{key == 10002 ? 'Delivery Challan' : 'Purchase Challan'}}{{ count > 1 ? "s are pending" : " is pending" }}</template>
									<template v-if="key == 10005">{{ count }} Estimate{{ count > 1 ? "s are pending" : " is pending" }}</template>
									<template v-if="key == 10003 || key == 20003">{{ key == 10003 ? 'Invoice' : 'Purchase Invoice' }}{{ count > 1 ? "s" : "" }} ({{ count }})</template>
								</v-list-tile-title>
							</v-list-tile-content>

							<v-list-tile-action style="justify-content:center;">
								<v-icon class="primary-color">keyboard_arrow_right</v-icon> 
							</v-list-tile-action>
						</v-list-tile>

						<v-list-tile class="ma-3" style="background-color:#edf0f7;border-radius: 8px;" v-if="!$parent.Form.pendingOrderAndChallan || !Object.keys($parent.Form.pendingOrderAndChallan).length">
							<v-list-tile-content>
								<v-list-tile-title font12>
									<!-- <span v-if="$parent.Form.transactionData.transactionListId == 10002">No Order is pending</span>
									<span v-if="$parent.Form.transactionData.transactionListId == 10003">No Order/Delivery Challan is pending</span>
									<span v-if="$parent.Form.transactionData.transactionListId == 10004">No Invoice</span> -->

									<template v-if="$parent.Form.transactionData.transactionListId == 10002 || $parent.Form.transactionData.transactionListId == 20002">{{ $parent.Form.transactionData.transactionListId == 10002 ? 'No Order is pending' : 'No Purchase Order is pending' }}</template>
									<template v-if="$parent.Form.transactionData.transactionListId == 10003 || $parent.Form.transactionData.transactionListId == 20003">{{ $parent.Form.transactionData.transactionListId == 10003 ? 'No Order/Delivery Challan is pending' : 'No Purchase Order/Challan is pending' }}</template>
									<template v-if="$parent.Form.transactionData.transactionListId == 10004 || $parent.Form.transactionData.transactionListId == 20004">{{ $parent.Form.transactionData.transactionListId == 10004 ? 'No Invoice' : 'No Purchase Invoice' }}</template>
								</v-list-tile-title>
							</v-list-tile-content>
						</v-list-tile>
					</v-list>
				</v-card-text>
			</v-card>
		</v-bottom-sheet>
	</div>
</template>

<script>
export default{
	props:['menuclick', 'closeDialog', 'formType'],
	data(){	
		return{
			orderChallanSheet: false,
		}
	},
	methods:{
		openDialogWeb: function () {	
			this.orderChallanSheet = true;
		},
		closeDialogWeb: function () {
			this.orderChallanSheet = false;
		},
		fn_openItems: function (typeId) {
			let type = null;
			if(this.formType == 'sale')
				type = typeId == 10001 ? 'loadsalesorder' : typeId == 10002 ? 'loadsaleschallan' : typeId == 10005 ? 'loadestimate' : 'loadsalesinvoice';
			else
				type = typeId == 20001 ? 'loadpurchaseorder' : typeId == 20002 ? 'loadpurchasechallan' : 'loadpurchaseinvoice';

			this.menuclick(null, null, type);
		}
	}
}
</script>

<style>
.pending-count-tile .v-list__tile.v-list__tile--link{
	background-color:#edf0f7 !important;
	padding-right: 0;
}
</style>


// WEBPACK FOOTER //
// src/components/transactions/forms/dialogs/dialog_pending_sheet.vue